import findIndex from "lodash/findIndex"
import get from "lodash/get"
import startsWith from "lodash/startsWith"
import isEmpty from "lodash/isEmpty"
import find from "lodash/find"
import { useEffect, useState, useRef } from "react"
import { ReactSVG } from "react-svg"
import getContentUrl from "utils-lib/getContentUrl"
import getLanguageRoute from "utils-lib/getLanguageRoute"
import { handleEnterPress } from "utils-lib/handleEnterPress"
import { KEY_CODE_MAPPING } from "constants-lib/keyCodes"
import { getWindow } from "utils-lib/getWindow"
import "./LanguageDropdown.scss"
import withRouter from "hoc-lib/router"
import NextImageWrapper from "../../../../../SSR/NextImageWrapper"

const ssrWindow = getWindow()

const SHOULD_SET_CUSTOMER_SELECTED_LANGUAGE = true

const LanguageDropdown = ({
  languages,
  siteLanguage,
  switchLanguage,
  intializeProductResults,
  noFrenchContent,
  setNoFrenchContent,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const optionRefs = {
    0: useRef(null),
    1: useRef(null),
    2: useRef(null),
  }

  useEffect(() => {
    setNoFrenchContent(false)

    ssrWindow.document.addEventListener(`click`, handleDocumentClick)
    return () =>
      ssrWindow.document.removeEventListener(`click`, handleDocumentClick)
  }, [])

  useEffect(() => {
    if (isOpen && optionRefs[0]?.current) {
      optionRefs[0]?.current?.focus()
    }
  }, [isOpen])

  const openDropdown = (e) => {
    e.stopPropagation()
    if (dropdownRef?.current?.contains(e.target) && isOpen) {
      setIsOpen(false)
    } else {
      setIsOpen(true)
    }
  }

  const closeDropdown = () => setIsOpen(false)

  /* this handler catches all click events that fall outside of the parent element */
  const handleDocumentClick = (e) =>
    dropdownRef.current &&
    !dropdownRef.current.contains(e.target) &&
    closeDropdown()

  const handleLanguageChange = updateLanguageSelection(
    languages,
    siteLanguage,
    closeDropdown,
    switchLanguage,
    ssrWindow,
    intializeProductResults,
  )

  const renderSwitcher = () => {
    if (!isOpen) {
      return null
    }

    return (
      <div
        style={{
          background: `#DAE4E1`,
          // borderRadius: `.3rem`,
          borderBottomLeftRadius: `24px`,
          borderBottomRightRadius: `24px`,
          // boxShadow: `0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)`,
          cursor: `pointer`,
          position: `absolute`,
          top: `2rem`,
          width: `100%`,
          zIndex: 101,
          outline: `none`,
          left: `0rem`,
        }}
        className="languageDropdown_inner"
        role="listbox"
        aria-label={languages[langIndex]?.label}
      >
        {languages.map((lang, i) => {
          if (noFrenchContent && lang.code === "fr_CA") {
            return null
          }

          const langLabel = get(lang, `code`, ``)
            .toLowerCase()
            .replace(`_`, `-`)

          return (
            <button
              type="button"
              aria-selected={lang.label === languages[langIndex]?.label}
              role="option"
              ref={optionRefs[i]}
              className={`${
                lang.label === languages[langIndex]?.label
                  ? `LanguageDropdown__option__selected`
                  : `LanguageDropdown__option`
              } px-3 py-2 d-flex align-items-center w-100`}
              // eslint-disable-next-line react/no-unknown-property
              analytics_key={lang.code}
              key={lang.code}
              tabIndex="0"
              onClick={(event) => {
                handleLanguageChange(
                  {
                    value: lang.code,
                  },
                  event,
                )
              }}
              // eslint-disable-next-line consistent-return
              onKeyDown={(e) => {
                if (e.shiftKey && e.code === "Tab") {
                  e.preventDefault()
                  const prevOption = optionRefs[i - 1] || optionRefs[2]
                  if (!!prevOption && !!prevOption.current) {
                    prevOption.current.focus()
                  }
                } else if (e.keyCode === KEY_CODE_MAPPING.TAB) {
                  e.preventDefault()
                  const nextOption = optionRefs[i + 1] || optionRefs[0]
                  if (!!nextOption && !!nextOption.current) {
                    nextOption.current.focus()
                  }
                } else if (e.keyCode === KEY_CODE_MAPPING.ESCAPE) {
                  e.preventDefault()
                  isOpen && closeDropdown()
                } else if (e.code.includes("Shift")) {
                  e.preventDefault()
                } else {
                  return handleEnterPress(
                    e,
                    handleLanguageChange(
                      {
                        value: lang.code,
                      },
                      e,
                    ),
                  )
                }
              }}
            >
              {/* <div
                className="LanguageDropdown__image-container"
                style={{ width: `2.5rem` }}
              >
                <img
                  alt=""
                  className="LanguageDropdown__image"
                  src={getContentUrl(lang.url)}
                />
              </div> */}
              <div
                className="LanguageDropdown__label  maax-font-weight-regular"
                lang={langLabel}
              >
                {lang.label}
              </div>
            </button>
          )
        })}
      </div>
    )
  }

  // Get the AEM language object.
  const langIndex = findIndex(
    languages,
    (lang) => lang.code === siteLanguage?.language,
  )

  const langLabel = get(languages[langIndex], `code`, ``)
    .toLowerCase()
    .replace(`_`, `-`)

  const closeIcon = getContentUrl(
    "/content/dam/wm/icons/controls/20x20/green1/material-ui/arrow-up.svg",
  )
  const openIcon = getContentUrl(
    "/content/dam/wm/icons/controls/20x20/green1/material-ui/arrow-down.svg",
  )
  return (
    <button
      id="langButton"
      data-testid="langButton"
      className={`LanguageDropdown ${
        isOpen ? `dropdown-open` : `dropdown-close`
      } d-flex align-items-center`}
      tabIndex="0"
      type="button"
      aria-label="language dropdown"
      aria-haspopup="listbox"
      aria-labelledby="langLabel"
      aria-expanded={isOpen}
      onClick={openDropdown}
      style={{
        cursor: `pointer`,
        position: `relative`,
        outline: `none`,
      }}
      onKeyDown={(e) => {
        if (e.keyCode === KEY_CODE_MAPPING.ESCAPE) {
          e.preventDefault()
          isOpen && closeDropdown()
        } else {
          handleEnterPress(e, () => {
            e.preventDefault()
            openDropdown(e)
          })
        }
      }}
      // eslint-disable-next-line react/no-unknown-property
      analytics_key="Language Dropdown"
    >
      <label id="langLabel" className="sr-only">
        {`Selected Language - ${languages[langIndex]?.label}`}
      </label>
      <div ref={dropdownRef} className="d-flex align-items-center">
        {renderSwitcher()}
        <div
          className="wm-link-light-green maax-font-weight-regular bg-transparent text-nowrap"
          style={{
            paddingLeft: ".5rem",
          }}
          lang={langLabel}
        >
          {languages[langIndex]?.label}
        </div>
        <NextImageWrapper
          wrapper="span"
          src={isOpen ? closeIcon : openIcon}
          alt={isOpen ? "open icon" : "close icon"}
          nextImageProps={{
            height: 18,
            width: 18,
            loading: "eager",
          }}
          renderLegacyComponent={(props) => <ReactSVG {...props} />}
        />
      </div>
    </button>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// LanguageDropdown.propTypes = {
//   languages: PropTypes.array.isRequired,
//   siteLanguage: PropTypes.object.isRequired,
//   switchLanguage: PropTypes.func.isRequired,
//   intializeProductResults: PropTypes.func.isRequired,
//   setNoFrenchContent: PropTypes.func.isRequired,
//   noFrenchContent: PropTypes.bool.isRequired,
// }

export default withRouter(LanguageDropdown)
export function updateLanguageSelection(
  languages,
  siteLanguage,
  closeDropdown,
  switchLanguage,
  ssrWindow,
  intializeProductResults,
) {
  return (selectedLang, event) => {
    event.stopPropagation()
    const language = find(
      languages,
      (lang) => lang.code === siteLanguage.language,
    )

    if (selectedLang.value === language.code) {
      closeDropdown()
      return
    }

    switchLanguage(selectedLang.value, SHOULD_SET_CUSTOMER_SELECTED_LANGUAGE)
    const pathname = `${ssrWindow.location.pathname}${ssrWindow.location.search}`
    const isCurrentPathEnglish =
      pathname.indexOf(`/ca/en`) !== -1 || pathname.indexOf(`/us/en`) !== -1
    const isCurrentPathFrench = pathname.indexOf(`/ca/fr`) !== -1
    const isCurrentPathSpanish = pathname.indexOf(`/us/es`) !== -1
    const isPathLocalized =
      isCurrentPathEnglish || isCurrentPathFrench || isCurrentPathSpanish
    const languageRoute = getLanguageRoute(selectedLang.value)
    let finalUrl = ``
    const pdpElement = ssrWindow.document.getElementById(`product-selection`)
    const prodAvaulabilityElem = ssrWindow.document.getElementById(
      "product-availability",
    )
    if (!isEmpty(pdpElement) || !isEmpty(prodAvaulabilityElem)) {
      intializeProductResults()
    }
    if (isPathLocalized) {
      const isSelectedLangCurrentPathLang = startsWith(pathname, languageRoute)
      if (!isSelectedLangCurrentPathLang) {
        finalUrl = `${languageRoute}${pathname.substr(6)}`
      }
    } else {
      finalUrl = `${languageRoute}${pathname.length > 1 ? pathname : ``}`
    }

    // eslint-disable-next-line no-param-reassign
    ssrWindow.location = finalUrl

    closeDropdown()
  }
}
